<div>
  <h2 mat-dialog-title>{{title}}</h2>
  <mat-dialog-content>
    @if (message) {
      <p style="max-width:560px;font-size:var(--text-sm);line-height:1.6" [innerHTML]="message"></p>
    }
    @if (htmlContent) {
      <div style="max-width:560px;font-size:var(--text-sm)" [innerHTML]="htmlContent"></div>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    @if (negativeButtonText) {
      <button mat-button (click)="onNegativeClick()">{{negativeButtonText}}</button>
    }
    @if (neutralButtonText) {
      <button mat-button (click)="onNeutralClick()">{{neutralButtonText}}</button>
    }
    @if (positiveButtonText) {
      <button mat-flat-button [color]="isPositivePrompt ? 'primary' : 'warn'" (click)="onPositiveClick()">
        {{positiveButtonText}}
      </button>
    }
  </mat-dialog-actions>
</div>
